<template>
    <div>                             
        <div class="task-kanban-holder">
             <!-- {{kanbanData}} -->
            <div class="to-do-holder">
                <h4 class="text-center">To Do</h4>
               <draggable 
                group="id" 
                :list="toDoList"
                :id="1"
               :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in toDoList" >
                <div class="card-holder">
                    <div class="flex justify-between items-center">
                        <h6 class="mb-4 cursor-pointer" @click="showModalForEdit(taskListing)"><b>{{taskListing.name}}</b></h6>
                        
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <!-- <p class="name">{{userInfo.first_name}}</p> -->
                        <p class="name" v-if="taskListing.project !== null">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                  
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2">
                                <feather-icon icon="ClockIcon" />
                                <span>{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>

                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                        <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                          <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                        </vs-tooltip>
                        <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                          <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                        </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
                 
            </div>

           <div class="progress-holder">
                <h4 class="text-center">In Progress</h4>
            
               <draggable :list="inProgressList"  group="id"
               :id="2"
                :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in inProgressList" >

                <div class="card-holder">
                    <div class="flex justify-between items-center">
                      <h6 class="mb-4 cursor-pointer" @click="showModalForEdit(taskListing)"><b>{{taskListing.name}}</b></h6>
                  
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <p v-if="taskListing.project" class="name">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2">
                                <feather-icon icon="ClockIcon" />
                                <span>{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>

                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
                 
            </div>

           <div class="done-holder">
                <h4 class="text-center">Done</h4>
               <draggable :list="doneList"  group="id"
               :id="3"
               :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in doneList" >

                <div  class="card-holder">
                    <div class="flex justify-between items-center">
                        <h6 class="mb-4 cursor-pointer" @click="showModalForEdit(taskListing)"><b>{{taskListing.name}}</b></h6>
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <!-- <p class="name">{{userInfo.first_name}}</p> -->
                        <p v-if="taskListing.project" class="name">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2">
                                <feather-icon icon="ClockIcon" />
                                <span>{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
            </div>
        </div>
        <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="kanbanActive" :class="{show: kanbanActive}">
          <div class="cstm-modal">
            <div class="header">
              <h3>Task Details</h3>
              <button @click="kanbanActive = false" class="close-modal">&times;</button>
            </div>
            <div class="each-tabular p-4 modal-content">
                <div class="cstm-unique-tab-text">
                    <div class="px-2">
                        <div class="flex flex-wrap -mx-2">
                            <div class="md:w-1/2 w-full px-2 my-2">
                              <strong class="block">Name:</strong> {{taskData.name}}
                            </div>
                            <div class="md:w-1/2 w-full px-2 my-2">
                            <v-select
                                v-model="taskData.task_priority_id"
                                v-validate="'required'"
                                :reduce="option => option.id"
                                label="level"
                                name="level"
                                :options="priority"
                                :disabled="true"
                                placeholder="Choose Priority"
                                style="width:100%;"
                                /></div>
                                <div class="w-full px-2 my-2">
                                   <select v-model="taskData.task_status_id" @change="StatusChnage(taskData)" name="cars" id="cars" form="carform" class="w-100 selectExample mt-2 customSelect">
      <option :key="index" :value="item.id" :label="item.status" v-for="(item,index) in options" class="selectOptionclass"/>
    </select>
                                </div>
                            <div class="w-full px-2 my-2">
                              <strong class="block">Details:</strong>  {{taskData.details}}
                            </div>
                            <div class="md:w-1/2 w-full px-2 my-2">
                                <div class="person-holder">
                                    <div class="w-full">
                                        <feather-icon icon="UserIcon" />
                                        <strong>Responsible Person</strong>
                                    </div>
                                    <div class="flex-wrap">
                                          <span class="mr-1" :key="index4" v-for="(person, index4) in responsibleData" >
                    {{person.first_name}} {{person.last_name}}
                    <span v-if="index4+1 < responsibleData.length">,</span>
                </span>
                                    </div>
                                </div>
                            </div>
                            <div class="md:w-1/2 w-full px-2 my-2">                                
                                <strong class="block">Deadline:</strong>
                                {{taskData.due_date}}
                                                                
                            </div>
                            <vs-divider />
                            <vs-tabs class="inner-tab tooltip_icon_tab">
                                <vs-tab label="Created By" icon-pack="feather" icon="icon-users">
                                    <div class="my-2">
                          <div class="flex items-center">
                              <feather-icon icon="UserIcon" />
                              <span class="mx-1">Created By</span>
                          </div>
                          <div class="flex flex-wrap -mx-2">
                              <div class="w-full px-2">
                                <strong class="block my-2">{{taskData.created_by.first_name}} {{taskData.created_by.last_name}}</strong>
                              </div>
                          </div>
                      </div>

                      <div class="my-2">
                          <div class="flex items-center">
                              <feather-icon icon="UserIcon" />
                              <span class="mx-1">Participants</span>
                          </div>
                          <div class="flex flex-wrap -mx-2">
                              <div class="cstm-inp flex-wrap">
                                <span class="cstm-badge flex items-center mb-2" :key="index4" v-for="(person, index4) in participantData">
                                                          {{person.first_name}} {{person.last_name}}
                                                      </span>                
                              </div>
                          </div>
                      </div>

                                    <div class="my-2">
                          <div class="flex items-center">
                              <feather-icon icon="UserIcon" />
                              <span class="mx-1">Observers</span>
                          </div>
                          <div class="flex flex-wrap -mx-2">
                              <div class="cstm-inp flex-wrap">
                                  <span class="cstm-badge flex items-center mb-2" :key="index4" v-for="(person, index4) in observerData">
                                                          {{person.first_name}} {{person.last_name}}
                                                      </span>
                              </div>
                          </div>
                      </div>
                                </vs-tab>

                                <vs-tab label="Time Planning" icon-pack="feather" icon="icon-clock">
                                    <div>
                                        <div class="flex items-center my-2">
                                            <feather-icon icon="ClockIcon" />
                                            <span class="mx-1">Time Planning</span>
                                        </div>
                                        From: {{taskData.from_time}} &nbsp;<br>
                                        To: {{taskData.to_time}}
                                        <vs-divider />
                                        <div v-if="taskData.is_tracking_active">
                                        <div v-if="participantData.find(u => u.id == userInfo.basic_details.client_users_id)">
                                            <div class="flex items-center my-2">
                                                <feather-icon icon="ClockIcon" />
                                                <span class="mx-1">Log</span>
                                            </div>
                                        <div class="flex flex-wrap items-center" :key="index10" v-for="(log, index10) in logs">
                                            <vs-input class="width-10" v-model="log.no_of_days" type="number" />
                                            <span class="mx-2">Days</span>
                                            <vs-input class="width-10" v-model="log.no_of_hours" type="number" />
                                            <span class="mx-2">Hour</span>
                                        </div><br>
                                        <vs-button @click="addLog">+ Log</vs-button>&nbsp;
                                        <vs-button color="success" @click="submitLog(live_update_id)">Save</vs-button>
                                        
                                        <div>
                                            <div class="flex items-center my-2">
                                                <feather-icon icon="ClockIcon" />
                                                <span class="mx-1">Log History</span>
                                                </div>
                                                <div class="cstm-badge flex items-center" :key="index10" v-for="(log, index10) in logHistory">
                                            {{log.no_of_days}}
                                            <span class="mx-2">Days</span>
                                            {{log.no_of_hours}}
                                            <span class="mx-2">Hour</span>
                                        </div>
                                        <br>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                </vs-tab>

                                  <vs-tab label="Assignment" icon-pack="feather" icon="icon-list">
                    <span v-if="taskData.checklist.length !== 0">
                                            <span :key="index8" v-for="(item1, index8) in taskData.checklist">
                                              <div class="flex flex-wrap items-center">
                                              <div class="flex items-center my-2 lg:w-1/5 w-full">
                                                    <span class="material-icons">assignment</span>
                                                    <span class="mx-2">{{item1.name}}</span>
                                              </div>
                                                  <vs-progress class="lg:w-1/2 md:w-3/5" :percent="(item1.itemStatusCal.length/item1.todos.length)*100" color="primary"></vs-progress>
                                                  <div class="progress-status">
                                                      Completed: {{item1.itemStatusCal.length}} out of {{item1.todos.length}}
                                                  </div>
                                              </div>
                                                  <ul class="task-checklist mb-4" >
                                                  <li class="flex justify-between"  :key="index9" v-for="(item2, index9) in item1.todos">
                                                    {{item2.todo}}
                                                  </li> 
                                                  </ul>
                                            </span>  
                                        </span>
                  </vs-tab>

                                <vs-tab label="Project" icon-pack="feather" icon="icon-grid">
                      <div>
                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">Project</label>
                              <div class="cstm-inp w-1/2">
                                               <span v-if="showDataForProject"> {{showDataForProject.name}}</span>
                                                </div>
                          </div>
                          <vs-divider />

                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">Remind about task</label>
                              <div class="inline-flex items-center m-1" :key="index" v-for="(item, index) in reminderTime">
                                                        {{item.reminder_time}}
                                                    </div>
                          </div>
                          <vs-divider />

                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">Gantt</label>
                          </div>
                          <vs-divider />

                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">CRM</label>
                                <span class="cstm-badge flex items-center" :key="index8" v-for="(crm, index8) in selectedCRMData">
                                                    <span v-if="crm.lead_first_name != ''">{{crm.lead_first_name}}</span><span v-if="crm.lead_middle_name != ''">&nbsp;{{crm.lead_middle_name}}</span><span v-if="crm.lead_last_name != ''">&nbsp;{{crm.lead_last_name}}</span>
                                                </span>
                          </div>
                          <vs-divider />

                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">SubTask</label>
                              <span class="cstm-badge flex items-center" :key="index8" v-for="(task, index8) in selectedSubTaskData">
                                                    {{task.name}}
                                                </span>
                          </div>
                          <vs-divider />

                          <div class="flex flex-wrap items-center">
                              <label class="w-1/5">Tags</label>
                                <v-select
                                                        class="w-full"
                                                        label="name"
                                                        taggable
                                                        :reduce="(option) => option.name"
                                                        :create-option="
                                                        (option) => ({ id: option, label: option, name: option })
                                                        "
                                                        :options="tagsList"
                                                        v-model="taskData.tags"
                                                        :clearable="false"
                                                        data-vv-name="name"
                                                        name="name"
                                                        :disabled="true"
                                                        multiple
                                                    >
                                                    </v-select>
                          </div>
                          
                      </div>
                  </vs-tab>
                                <vs-tab label="Editor" icon-pack="feather" icon="icon-type">
                    <div class="flex items-center">
                      <p v-html="taskData.comments"></p>
                    </div>
                  </vs-tab>
                            </vs-tabs>
                          
                        </div>
                    </div>
                    
                </div>
            </div>
          </div>
        </div>
        
    </div>
</template>
<script>
import { taskUpdate } from '@/api/task-project.js'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import { TaskProject } from '../mixins/task-project.js'

export default {
  name: 'kanban',
  props: ['liveData'],
  data () {
    return {
      kanbanData: this.liveData,
      toDoList: [], //status->1
      inProgressList: [], //staus->2
      doneList: [], //status->
      userInfo: JSON.parse(localStorage.getItem('Clientuser')),
      selectedTab: null
    }
  },
  components: {
    'v-select': vSelect,
    draggable
  },
  mixins: [TaskProject],
  mounted () {
    this.filterKanbanData()
    //this.fetchTaskUpdate(this.query_page_data.page)
    this.priorityList()
  },
  methods: {
    filterKanbanData () {
      this.toDoList = this.kanbanData.filter(ele => {
        return ele.status.id === 1
      })
      this.inProgressList = this.kanbanData.filter(ele => {
        return ele.status.id === 2
      })
      this.doneList = this.kanbanData.filter(ele => {
        return ele.status.id === 3
      })
    },
    StatusChnage (data) {
      const payload = {
        updateField: {task_status_id: data.task_status_id}
      }
      taskUpdate(this.live_update_id, payload)
        .then((res) => {
          this.successMessage('Status changed successfully')
          res.data.data.task.status_list = this.priority
          res.data.data.task.live_status_list = this.options
          const afterUpdate = [res.data.data.task]
          this.kanbanData = this.kanbanData.map(obj => afterUpdate.find(o => o.id === obj.id) || obj)
          this.filterKanbanData()
        })
        .catch((e) => {
          console.log(e)
          this.warningMessage('Something went wrong')
        })
    },
    checkMove (evt) {
      console.log(evt.draggedContext.element)
      console.log(evt)
      const id = evt.draggedContext.element.id
      
      const changestatusTo = evt.to.id
      const payload = {
        updateField: {
          task_status_id: changestatusTo
        }
      }
      if (evt.from.id !== evt.to.id) {
        this.kanbanStatusUpdate(id, payload)
      }
    },
    async kanbanStatusUpdate (id, payload) {
      try {
        const data = await taskUpdate(id, payload)
        data.data.data.task.status_list = this.priority
        data.data.data.task.live_status_list = this.options
        const afterUpdate = [data.data.data.task]
        this.kanbanData = this.kanbanData.map(obj => afterUpdate.find(o => o.id === obj.id) || obj)
        this.filterKanbanData()
        this.successMessage('Status changed successfully')
      } catch (apiError) {
        console.log(apiError)
      }
    },
    successMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    }, 
    warningMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
        time: 3000
      })
    }
  }
}
</script>

<style>
    .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }
</style>